// extracted by mini-css-extract-plugin
export default {"IonInput":"Input_IonInput__OdE3V","IonInput_active":"Input_IonInput_active__JaD-b"};